const SET_LOADER = {
  LOADING: 'ADMIN::LOADING',
};
export default SET_LOADER
